/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class HomeActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'home';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private navigationController: NavController,
    private zone: NgZone,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(this.constructor.name, 'Home action triggered');
    this.zone.run(() => {
      this.navigationController.navigateRoot('tabbar');
    })
  }

  // Private Functions
}
